<script setup lang="ts">
import { locale } from "../../../../locale";
import { viewState } from "../../../../states/viewState";
import BasePopoverItem from "./BasePopoverItem.vue";

const props = defineProps<{
  close: () => void;
}>();
const showSpeakerInShare = () => {
  viewState.showSpeakerInDemo = true;
  props.close();
};
const hideSpeakerInShare = () => {
  viewState.showSpeakerInDemo = false;
  props.close();
};
</script>
<template>
  <BasePopoverItem
    v-if="viewState.showSpeakerInDemo === false"
    :text="locale.showSpeakerInShare"
    @click.stop="showSpeakerInShare"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.10209 17.2506C4.10712 17.209 4.11292 17.1655 4.11952 17.1201C4.17974 16.7067 4.29838 16.1974 4.46125 15.7045C4.62621 15.2052 4.82296 14.7642 5.02324 14.4642C5.16188 14.2565 5.2492 14.1924 5.27505 14.175C5.49735 14.1871 5.75535 14.2966 6.27782 14.5475L6.6012 13.8741L6.27782 14.5475L6.283 14.55C7.09524 14.94 8.22264 15.4815 10.0002 15.4815C11.7778 15.4815 12.9052 14.94 13.7174 14.55L13.7226 14.5475C14.245 14.2966 14.503 14.1871 14.7253 14.175C14.7512 14.1924 14.8385 14.2566 14.977 14.4642C15.1773 14.7642 15.374 15.2051 15.5389 15.7044C15.7017 16.1973 15.8203 16.7066 15.8805 17.1201C15.8871 17.1654 15.8929 17.209 15.8979 17.2506H9.87651H4.10209Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M13.9498 9.04375C13.9498 11.2253 12.1813 12.9937 9.9998 12.9937C7.81828 12.9937 6.0498 11.2253 6.0498 9.04375C6.0498 6.86223 7.81828 5.09375 9.9998 5.09375C12.1813 5.09375 13.9498 6.86223 13.9498 9.04375Z"
        stroke="white"
        stroke-width="1.5"
      />
      <rect
        x="1.75"
        y="2.75"
        width="16.5"
        height="14.5"
        rx="1.25"
        stroke="white"
        stroke-width="1.5"
      />
    </svg>
  </BasePopoverItem>
  <BasePopoverItem
    v-else
    :text="locale.hideSpeakerInShare"
    @click.stop="hideSpeakerInShare"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.10209 17.2506C4.10712 17.209 4.11292 17.1655 4.11952 17.1201C4.17974 16.7067 4.29838 16.1974 4.46125 15.7045C4.62621 15.2052 4.82296 14.7642 5.02324 14.4642C5.16188 14.2565 5.2492 14.1924 5.27505 14.175C5.49735 14.1871 5.75535 14.2966 6.27782 14.5475L6.6012 13.8741L6.27782 14.5475L6.283 14.55C7.09524 14.94 8.22264 15.4815 10.0002 15.4815C11.7778 15.4815 12.9052 14.94 13.7174 14.55L13.7226 14.5475C14.245 14.2966 14.503 14.1871 14.7253 14.175C14.7512 14.1924 14.8385 14.2566 14.977 14.4642C15.1773 14.7642 15.374 15.2051 15.5389 15.7044C15.7017 16.1973 15.8203 16.7066 15.8805 17.1201C15.8871 17.1654 15.8929 17.209 15.8979 17.2506H9.87651H4.10209Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M13.9498 9.04375C13.9498 11.2253 12.1813 12.9937 9.9998 12.9937C7.81828 12.9937 6.0498 11.2253 6.0498 9.04375C6.0498 6.86223 7.81828 5.09375 9.9998 5.09375C12.1813 5.09375 13.9498 6.86223 13.9498 9.04375Z"
        stroke="white"
        stroke-width="1.5"
      />
      <rect
        x="1.75"
        y="2.75"
        width="16.5"
        height="14.5"
        rx="1.25"
        stroke="white"
        stroke-width="1.5"
      />
    </svg>
  </BasePopoverItem>
</template>
